import sc from 'styled-components';

export const StyledGrid = sc.div.withConfig({
	shouldForwardProp: (prop) => !['$columns', '$gap'].includes(prop),
})<{$columns: number; $gap?: string}>`
    display: grid;
    width: 100%;
    height: 100%;
    grid-template-columns: ${({$columns}) => `repeat(${$columns}, 1fr)`};
    grid-template-rows: auto;
    grid-column-gap: ${({$gap}) => $gap || '0px'};
    grid-row-gap: ${({$gap}) => $gap || '0px'};
`;